// export const toCurrency = (num, decimal = 2)=> {
//     return  Number.parseFloat(num).toFixed(decimal);
// }


export const toCurrency = (num, decimal = 2) => {
  if (num.toString().includes('.')) {
    var parts = (+(Math.round(num + "e+2") + "e-2")).toString().split(".");
    console.log('parts[0] ', parts[0]);
    console.log('parts[1]', parts[1])
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (!parts[1]) return parts[0] + ".";

    if (parts[1] && parts[1].length > decimal)
      parts[1] = parts[1].substr(0, decimal);

    return parts.join(".");
  }
  else {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export const toNumber = (num, decimal = 2) => {
  return Number.parseFloat(num).toFixed(decimal);
}

// console.log(toCurrency(123123.123123123));


// WEBPACK FOOTER //
// ./src/utility/number.js